import {AxiosCall} from '../axios';
import {serializeQueryParams} from './PaymentHistoryService';
import {ServiceSuccessResponseType} from './service-mappers/BaseMapper';
import {ArrayResponse} from './service-mappers/CommonServiceMapper';
import {
  IProcedure,
  IProcedureInputField
} from './service-mappers/SmartCoderServiceMapper';

export const getAllProcedures = async ({
  clinicGroupId,
  clinicId,
  params
}: {
  clinicGroupId: number;
  clinicId: number;
  params?: {
    type?: string;
  };
}): Promise<ServiceSuccessResponseType<ArrayResponse<IProcedure[]>>> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/smart-coder/procedure/all?${queryParams}`
  );
};

export const getAllHcpcsCodes = async ({
  clinicGroupId,
  clinicId,
  params
}: {
  clinicGroupId: number;
  clinicId: number;
  params?: {
    label?: string;
    name_id?: string;
  };
}): Promise<ServiceSuccessResponseType<any[]>> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/smart-coder/hcpcs/all?${queryParams}`
  );
};

export const getProcedureInputFields = async ({
  clinicGroupId,
  clinicId,
  procedureId
}: {
  clinicGroupId: number;
  clinicId: number;
  procedureId: number;
}): Promise<
  ServiceSuccessResponseType<ArrayResponse<IProcedureInputField[]>>
> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/smart-coder/procedure/${procedureId}/fields`
  );
};

export const generateProcedureCPTCode = async ({
  clinicGroupId,
  clinicId,
  payload
}: {
  clinicGroupId: number;
  clinicId: number;
  payload: any;
}): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/smart-coder/generate-cpt-code`,
    payload
  );
};

export const getCPTCodesResult = ({
  clinicGroupId,
  clinicId,
  params
}: {
  clinicGroupId: number;
  clinicId: number;
  params: {
    related_type: string;
    related_id: number;
  };
}): Promise<any> => {
  let queryParams = '';
  if (params) {
    queryParams = serializeQueryParams(params);
  }
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/smart-coder/cpt-code?${queryParams}`
  );
};
